import "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/token-icon/repositories/one-inch.repository.ts
import { ChainId } from "@one-inch-community/models";
var oneInchRepository = ({ address, chainId }) => {
  return new Promise((resolve, reject) => {
    if (!address || chainId !== ChainId.eth) return reject();
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = `https://tokens-data.1inch.io/images/${address.toLowerCase()}.png`;
  });
};
export {
  oneInchRepository
};
//# sourceMappingURL=one-inch.repository-AF3TE4XT.js.map
